import React, { useContext, useState } from 'react'
import { Button, Card, Slider, CardContent, Typography, ClickAwayListener } from '@mui/material'
import CreateIcon from '@mui/icons-material/Create'
import OpacityIcon from '@mui/icons-material/Opacity'
import ArrowDropDown from '@mui/icons-material/ArrowDropDown'
import AutoPolyIcon from '@mui/icons-material/Brush'
import AutoFixHighIcon from '@mui/icons-material/AutoFixHigh'

import CahngeCatIcon from '../../../icons/PaintBucket'
import EraserIcon from '../../../icons/Eraser'
import { LabelerContext } from '../../../containers/labeler/context/LabelerContext'
import { DispatchContext } from '../../../containers/labeler/context/DispatchContext'
import { getUser } from '../../../utils/util'
import BarTooltip from '../BarTooltip'
import useFreeTrial from '../../../pages/project/hooks/useFreeTrial'

export default function SegmentationButtons(props) {
  const { permissionsFreeTrial } = useFreeTrial()
  const {
    state: {
      labelerState: { mode },
      segmentationState: { globalAlpha }
    }
  } = useContext(LabelerContext)
  const { dispatch } = useContext(DispatchContext)

  const [openGlobalAlpha, setOpenGlobalAlpha] = useState(false)

  const handleClickAway = () => {
    setOpenGlobalAlpha(false)
  }

  const handlerValueGlobalAlpha = (e, value) => {
    dispatch({ type: 'setGlobalAlpha', payload: value })
  }

  const handlerMode = (e) => {
    dispatch({
      type: 'setLabelerMode',
      payload: { category: 'segmentation', mode: e.currentTarget.name }
    })
  }

  const handlerGlobalAlpha = () => {
    globalAlpha === 0.5
      ? dispatch({ type: 'setGlobalAlpha', payload: 1 })
      : dispatch({ type: 'setGlobalAlpha', payload: 0.5 })
  }

  const isPaid = getUser() ? getUser().paid : false

  return (
    <>
      {openGlobalAlpha && (
        <ClickAwayListener onClickAway={handleClickAway}>
          <Card style={{ position: 'fixed', top: 325, width: 150, left: '54px' }}>
            <CardContent>
              <Typography id="label">{'Global Alpha (' + globalAlpha + ')'}</Typography>
              <Slider
                value={globalAlpha}
                aria-labelledby="label"
                onChange={handlerValueGlobalAlpha}
                min={0}
                step={0.1}
                max={1}
              />
            </CardContent>
          </Card>
        </ClickAwayListener>
      )}
      <BarTooltip onClick={handlerGlobalAlpha} title="Add/Remove Transparency">
        <div style={{ position: 'relative' }}>
          <OpacityIcon fontSize="small" />
          <Button
            style={{ position: 'absolute', bottom: 0 }}
            onClick={(e) => {
              setOpenGlobalAlpha(true)
              e.stopPropagation()
            }}
            sx={{
              minWidth: 1,
              width: 1,
              height: 5
            }}
          >
            <ArrowDropDown fontSize="small" />
          </Button>
        </div>
      </BarTooltip>
      <BarTooltip title="Add segmentation">
        <Button
          sx={
            mode === 'draw'
              ? { minWidth: 48, width: 48, background: 'rgba(120,120,120,0.3)' }
              : { minWidth: 48, width: 48 }
          }
          size="small"
          name="draw"
          onClick={handlerMode}
        >
          <CreateIcon fontSize="small" />
        </Button>
      </BarTooltip>
      <BarTooltip title="Delete segmentation">
        <Button
          sx={
            mode === 'erase'
              ? { minWidth: 48, width: 48, background: 'rgba(120,120,120,0.3)' }
              : { minWidth: 48, width: 48 }
          }
          size="small"
          name="erase"
          onClick={handlerMode}
        >
          <EraserIcon fontSize="small" />
        </Button>
      </BarTooltip>
      <BarTooltip title="Paint">
        <Button
          sx={
            mode === 'paint'
              ? { minWidth: 48, width: 48, background: 'rgba(120,120,120,0.3)' }
              : { minWidth: 48, width: 48 }
          }
          size="small"
          name="paint"
          onClick={handlerMode}
        >
          <CahngeCatIcon fontSize="small" />
        </Button>
      </BarTooltip>
      {isPaid && (
        <>
          <BarTooltip title="AutoPoly">
            <Button
              sx={
                mode === 'magig'
                  ? { minWidth: 48, width: 48, background: 'rgba(120,120,120,0.3)', fontSize: 8 }
                  : { minWidth: 48, width: 48, fontSize: 8 }
              }
              size="small"
              name="magic"
              labelStyle={{ fontSize: '63px' }}
              onClick={handlerMode}
            >
              <AutoPolyIcon fontSize="small" />
              {/* <span>BETA</span> */}
            </Button>
          </BarTooltip>

          <BarTooltip title="Magic">
            <Button
              sx={
                mode === 'magic-v2'
                  ? { minWidth: 48, width: 48, background: 'rgba(120,120,120,0.3)', fontSize: 8 }
                  : { minWidth: 48, width: 48, fontSize: 8 }
              }
              size="small"
              name="magic-v2"
              disabled={!props.isMagicEnable || (!getUser()?.paid && !permissionsFreeTrial)}
              labelStyle={{ fontSize: '63px' }}
              onClick={handlerMode}
            >
              <AutoFixHighIcon fontSize="small" />
              {/* <span>BETA</span> */}
            </Button>
          </BarTooltip>
        </>
      )}
    </>
  )
}
